<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col sm="12">
      <transition name="slide">
      <b-card body-class="pt-1">
        <div slot="header">
          <div class="row pl-2 pr-2">
            <b-col sm="12" lg="7" class="pt-2 p-1 title">
              <span :title="corporationSelected && corporationSelected.name">Usuários - {{corporationSelected && corporationSelected.name}}</span>
            </b-col>
            <b-col sm="12" lg="3" class="input-group input-group-sm p-1">
              <input class="form-control input-txt" id="txt-search" type="text" name="txt-search" v-model="filters.text" v-on:keyup.enter="search">
              <span class="input-group-append">
                <button id="btn-search" class="btn btn-success" type="button" title="Buscar" @click="search" @click.stop.prevent>
                  <i class="fa fa-search"></i>
                </button>
              </span>
              <b-dropdown class="input-group-append" title="Mais filtros" variant="success" ref="dropdownSearch">
                <b-dropdown-form class="drop-down-filter">
                  <h4>Mais filtros</h4>
                  <hr>
                  <b-form-checkbox class="mb-3" v-model="filters.status.removed">Removidos</b-form-checkbox>
                  <!-- <b-form-checkbox class="mb-3" v-model="filters.status.disabledUser">Bloqueados pelo usuário</b-form-checkbox> -->
                  <b-form-checkbox class="mb-3" v-model="filters.status.disabledCorporation">Bloqueados pela corporação</b-form-checkbox>
                  <b-form-checkbox class="mb-3" v-model="filters.status.enabled">Habilitados</b-form-checkbox>
                  <hr>
                  <b-form-group label="Tipo de usuário" label-for="userClass"></b-form-group>
                    <b-form-select id="userClass" class="mb-3" v-model="filters.userClass" :options="[
                      {value:null, text: 'Todos'},
                      {value:'user_corporation', text: 'Corporativo'},
                      {value:'user_signer', text: 'Assinante PJ'},
                    ]"></b-form-select>
                  <br>
                  <b-button variant="primary" size="sm" @click="search()">Filtrar</b-button>
                </b-dropdown-form>
              </b-dropdown>
            </b-col>
            <b-col sm="12" lg="2" class="p-1 btn-group">
              <b-button type="button" size="sm" title="Novo usuário" variant="success" class="btn-novo form-control" @click="userNew">Novo</b-button>
              <b-button type="button" size="sm" title="Operação em lote" variant="secondary" class="btn-novo form-control" @click="$router.push('users/batch')">Lote</b-button>
              <b-button type="button" size="sm" title="Exportar lista" variant="light" class="btn-novo form-control" style="max-width: 32px" @click="download()"><i class="fa fa-download"></i></b-button>
              <b-button type="button" size="sm" title="Importar assinantes PJ" variant="light" class="btn-novo form-control" style="max-width: 32px" @click="$router.push('users/signer-import')"><i class="fa fa-upload"></i></b-button>
            </b-col>
          </div>
        </div>
        <p class="lbl-filtro-descricao" v-if="filterDescription">
          <small class="text-muted" id="lbl-info">
            <i class="fa fa-filter"></i> {{ filterDescription }}
          </small>
        </p>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" 
          :items="items" :fields="fields" @row-clicked="rowClicked" :tbody-tr-class="getRowClass">
          <template slot="id" slot-scope="data">
            <strong>{{data.item.id}}</strong>
          </template>
          <template slot="username" slot-scope="data">
            <strong>{{data.item.username}}</strong>
          </template>
          <template slot="group" slot-scope="data">{{data.item.billingUserGroup && data.item.billingUserGroup.name}}</template>
          <template slot="userClass" slot-scope="data">{{getUserClassLabel(data.item.userClass)}}</template>
          <template slot="expireAt" slot-scope="data">{{data.item.expireAt && formatDate(data.item.expireAt.date, "dd/MM/yyyy")}}</template>
          <template slot="status" slot-scope="data">
            <b-badge :variant="getBadgeVariant(data.item.status)" :title="getStatusDetail(data.item.status)">
              <i :class="'fa fa-' + getStatusIcon(data.item.status) + ' fa-lg icon-status'"></i>
            </b-badge>
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @change="paginationChanged" prev-text="<<" next-text=">>" hide-goto-end-buttons/>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate } from '@/shared/utils';
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const STATUS_ENABLED = 0;
// const STATUS_DISABLED_USER = 1;
const STATUS_DISABLED_CORP = 2;
const STATUS_REMOVED = 4;
const STATUS_LOCKED = 8;

export default {
  name: 'Users',
  components: {
    Loading
  },
  props: {
    caption: {
      type: String,
      default: 'Usuários'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      fields: [
        {key: 'username', label: 'CPF/CNPJ'},
        {key: 'name', label: 'Nome'},
        {key: 'group', label: 'Grupo'},
        {key: 'userClass', label: 'Tipo'},
        {key: 'expireAt', label: 'Expiração'},
        {key: 'status'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      itemsByPage: {},
      filters: {
        text: null,
        status: {
          removed: null,
          disabledUser: true,
          disabledCorporation: true,
          enabled: true
        },
        userClass: null
      },
      filterDescription: null,
      loadCount: 0,
      urlParams: ''
    }
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    },
    ...mapState(['corporationSelected'])
  },
  watch: {
    async corporationSelected(corporation) {
      this.itemsByPage = {};
      await this.getUsers();
    }
  },
  methods: {
    formatDate (date, format) {
      return formatDate(date, (format || "dd/MM/yyyy hh:mm"));
    },
    getBadgeVariant (status) {
      if (status == 0) {
        return "success";
      }
      if ((status & 4) > 0) {
        return "secondary";
      }
      return "danger";
    },
    getRowClass(itm, type) {
      if (!itm || type !== "row") return;
      if (itm.status == STATUS_ENABLED) {
        return "";
      }
      if ((itm.status & STATUS_REMOVED) > 0) {
        return "tr-removed-user";
      }
      return "tr-locked-user";
    },
    getStatusIcon(status) {
      // if (status == STATUS_ENABLED) {
      //   return "check";
      // }
      if ((status & STATUS_REMOVED) > 0) {
        return "close";
      }
      if ((status & (STATUS_LOCKED | STATUS_DISABLED_CORP)) > 0) {
        return "lock"
      }
      return "check"
    },
    getUserClassLabel(userClass) {
      switch (userClass) {
        case 'user_signer':
          return "Assinante PJ"
        default:
          return "Corporativo"
      }
    },
    getStatusDetail(status) {
      var details = [];
      if (status == STATUS_ENABLED) {
        details.push("Ativo");
      } else {
        // if ((status & STATUS_DISABLED_USER) > 0) {
        //   details.push("Bloqueado usuário");
        // }
        if ((status & STATUS_DISABLED_CORP) > 0) {
          details.push("Bloqueado corporação");
        }
        if ((status & STATUS_REMOVED) > 0) {
          details.push("Removido");
        }
        if ((status & STATUS_LOCKED) > 0) {
          details.push("Bloqueado");
        }
      }
      return details.join(", ");
    },
    rowClicked (item) {
      this.$router.push({path: `users/edit/${item.id}`})
    },
    userNew () {
      this.$router.push('users/new');
    },
    paginationChanged (pageNumber) {
      this.getUsers(pageNumber);
    },
    search () {
      this.$refs.dropdownSearch.hide(true);
      this.getUsers(1);
    },
    getUsers (page = 1) {
      var cacheKey = JSON.stringify(this.filters) + page;
      if (this.itemsByPage[cacheKey]) {
        this.items = this.itemsByPage[cacheKey];
        this.currentPage = page;
        return;
      }
      this.setFilterDescription();
      this.urlParams = this.prepareParams(page);
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/corporation-user?${this.urlParams}`)
        .then(function(response) {
          _this.items = response.data._embedded.corporation_user;
          _this.currentPage = Math.max(response.data.page, 1);
          _this.itemsByPage[JSON.stringify(_this.filters) + _this.currentPage] = _this.items;
          _this.perPage = response.data.page_size;
          _this.totalRows = response.data.total_items;
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    async download () {
      var _this = this;
      this.loadCount++;
      var format = "csv";
      let urlParams = this.prepareParams(1);
      await axios
        .get(`${env.urlBillingApi}/corporation-user?${urlParams}&report`,
          { responseType: 'arraybuffer' })
        .then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const fileName = `lista-usuarios-${+ new Date()}.${format}`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    prepareParams(page) {
      let urlParam = `page=${page}`;
      if (this.filters.text) {
        urlParam += `&search=${this.filters.text}`;
      }
      let bitStatus = this.getBitStatus();
      urlParam += `&status=${bitStatus}`;
      if (!this.filters.status.enabled) {
        urlParam += `&hideEnabled=1`;
      }
      if (this.filters.userClass) {
        urlParam += `&userClass=${this.filters.userClass}`;
      }
      return urlParam;
    },
    getBitStatus() {
      let bitStatus = 0;
      if (this.filters.status.removed) {
        bitStatus += STATUS_REMOVED;
      }
      // if (this.filters.status.disabledUser) {
      //   bitStatus += STATUS_DISABLED_USER;
      // }
      if (this.filters.status.disabledCorporation) {
        bitStatus += STATUS_DISABLED_CORP;
      }
      return bitStatus;
    },
    setFilterDescription() {
      let desc = [];
      if (this.filters.text) {
        desc.push(this.filters.text)
      }
      let status = this.getBitStatus();
      if (status > 0) {
        desc.push(this.getStatusDetail(status));
        if (this.filters.status.enabled) {
          desc.push('Ativo')
        }
      }
      if (this.filters.userClass) {
        desc.push(this.getUserClassLabel(this.filters.userClass));
      }

      this.filterDescription = desc.join(', ');
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.search-area {
  max-width: 280px;
}
.icon-status {
  margin: 3px 0;
}
.card-body >>> table > tbody > .tr-removed-user {
  color: gray;
  text-decoration: line-through;
}
.card-body >>> table > tbody > .tr-locked-user {
  color: maroon;
}
.input-txt {
  height: 32px !important;
}
.drop-down-filter {
  font-family: 'Helvetica-Light';
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@media screen and (max-width: 468px) {
  .title {
    text-align: center;
  }
}
</style>
